import React from 'react'

export const BetaText = () => {
  return (
    <div className="text-platinum fw-bold d-inline text-11">BETA</div>
  )
}
 